import ProjectApiService from '@lib/api-services/ProjectApiService';
import ProjectConfigurationsApiService from '@lib/api-services/ProjectConfigurationsApiService';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ProjectConfigurationPage from './ProjectConfigurationPage';
import store from '@lib/store/configuration';

const ProjectConfigurationEditPage = class ProjectConfigurationEditPage extends ProjectConfigurationPage {
    constructor(props) {
        super(props)

        scheduleAtDocumentReady(() => {
            this.projectAPIService = APIServicesRegistry.getService(ProjectApiService);
            this.projectConfigurationsApiService = APIServicesRegistry.getService(ProjectConfigurationsApiService);
        })
    }

    save() {
        var a = !store.canSave();
        var b = store.hasIssuesAsForceToChange();

        if (a || b)
            return;


        if (!store.canSave())
            return;

        store.setDirty(false);

        var configuration = store.getTransformedFormModel()
        var data = {
            projectId: this.props.projectId,
            configuration: configuration
        }

        if (configuration.id === 0) {
            this.projectAPIService.createConfiguration(data)
        } else {
            this.projectAPIService.editConfiguration(data)
        }
    }

    onCopyButtonClick = () => {
        this.projectConfigurationsApiService.copyAndSave(this.props.projectId, this.props.id.value);
    }

    getDesktopActionButtons() {
        var buttons = [super.getDesktopActionButtons()]
        if (this.props.canEdit) {
            buttons.push(<Button key={1}
                                 onClick={() => this.onSetSerialNumberClick()}>{__('Set serial number')}</Button>)
        }

        return buttons;
    }
}

window.components.ProjectConfigurationEditPage = ProjectConfigurationEditPage